import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { Button, Form, Upload, message } from "antd";
import { isEmpty } from "lodash";
import { UploadOutlined } from "@ant-design/icons";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import { useSettingsStore } from "./store";

function SettingData({
  title,
  onCloseMoreModal,
}) {
  const [form] = Form.useForm();
  const { setToaster } = useToast();
  const [modalShow, setModalShow] = useState(false);
  const [fileData, setFileData] = useState({});
  const store = useSettingsStore();

  const getDataAndFunctions = () => {
    switch (title) {
      case "Serviceable Pincodes":
        return {
          data: store.pinCode,
          getDataFunction: store.getPincodeData,
          uploadFunction: store.uploadPincode,
          fileName:"serviceable-pincodes",
          codKey:"COD Serviceable Pincodes"
    };
      case "Non Serviceable Combinations":
        return {
          data: store.serviceableCombination,
          getDataFunction: store.getNonserviceableCombinatin,
          uploadFunction: store.uploadNonserviceablecombination,
          fileName:"non-serviceable-combinations",
          codKey:"COD nonServiceable Combination"
    
        };
      case "Blocked Customers":
        return {
          data: store.blockedCustomersData,
          getDataFunction: store.getBlockedCustomersData,
          uploadFunction: store.uploadblockedCustomers,
          fileName:"blocked-customers",
          codKey:"COD Blocked Customers"
    
        };
      default:
        return {
          data: null,
          getDataFunction: null,
          uploadFunction: null,
        };
    }
  };

const { data, getDataFunction, uploadFunction,fileName,codKey } = getDataAndFunctions();

  useEffect(() => {
    getDataFunction();
  }, []);

  const beforeUpload = (file) => {
    if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
      message.error(`only csv file allowed`);
      return true;
    }
    return false;
  };

  const downloadCSV = async (data, csvName) => {
    const opts = {
      delimiter: ",", // Set your desired delimiter
      header: true, // If your data has headers
      newline: "\n", // Set the newline character
    };

    const csvString = Papa.unparse(data, opts);

    // Create a Blob containing the CSV data
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8" });
    saveAs(blob, csvName);
  };

  const downloadSample = async () => {
    const _fileName = `${fileName}.csv`;

    if (Array.isArray(data)) {
      const codes = data?.reduce((acc, curr) => {
        if (curr) acc.push({ [codKey]: curr });
        return acc;
      }, []);
      await downloadCSV(codes, _fileName);
    }
  };

  const upload = async () => {
    let file = new FormData();
    file.append("file", fileData);
    uploadFunction(
      file,
      setToaster,
      getDataFunction,
      handleModalClose,
      onCloseMoreModal
    );
  };

  const handleFileUpload = (info) => {
    if (info.fileList.length !== 0) {
      setFileData(info.file);
    }
  };

  const resetFile = () => {
    setFileData({});
  };

  const handleModalClose = () => {
    form.resetFields();
    setModalShow(false);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="flex-4">
          <span>{title}</span>
        </div>
        <div className="flex-4 d-flex justify-content-between">
          <Button onClick={downloadSample}>Download</Button>
          <Button type="primary" onClick={() => setModalShow(true)}>
            Update
          </Button>
        </div>
      </div>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Update {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column gap-3 justify-content-center ">
            <Upload
              accept=".csv"
              className="text-center"
              name="file"
              beforeUpload={(file) => beforeUpload(file)}
              onChange={handleFileUpload}
              maxCount={1}
              onRemove={resetFile}
            >
              <Button icon={<UploadOutlined />}>Add File</Button>
            </Upload>
            <Button
              className="w-max mt-2"
              disabled={isEmpty(fileData)}
              loading={false}
              onClick={upload}
              type="primary"
            >
              Upload
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default SettingData;